import React from "react";
import { useGameContext } from "../context/GameContext";

// import { GameStatsType } from '../types/types'
import "./GameStats.css";

interface Props {
  gameStats: any; // GameStatsType ????
  dropTime: number;
}

const GameStats: React.FC<Props> = ({ gameStats, dropTime }) => {
  const { level, points, linesCompleted, linesPerLevel } = gameStats;
  const linesToLevel = linesPerLevel - linesCompleted;

  return (
    <ul className="GameStats">
      <li>Level</li>
      <li className="value">{level}</li>
      <li>Lines to level</li>
      <li className="value">{linesToLevel}</li>
      <li>Points</li>
      <li className="value">{points}</li>
      <li>Drop Speed</li>
      <li className="value">{dropTime}ms</li>
    </ul>
  );
};

export default React.memo(GameStats);
